import React, { useState } from "react";
import clsx from "clsx";
import styles from "./Accordion.module.css";

export const Accordion = ({
  header,
  onHeaderClick,
  classNames,
  children,
  open = true,
}) => {
  const [isOpen, setIsOpen] = useState(open);

  const headerContent = header instanceof Function ? header(isOpen) : header;

  const handleClick = () => {
    if (onHeaderClick) {
      const shouldProcess = onHeaderClick(isOpen);

      if (!shouldProcess) {
        return;
      }
    }

    setIsOpen(!isOpen);
  };

  return (
    <div className={clsx(styles.Accordion, classNames?.container)}>
      <div
        className={clsx(
          styles.AccordionHeader,
          isOpen && styles.Expanded,
          classNames?.header,
          isOpen && classNames?.expanded
        )}
        onClick={handleClick}
      >
        {headerContent}
      </div>

      <div
        className={clsx(
          styles.AccordionBody,
          isOpen && styles.Expanded,
          classNames?.body,
          isOpen && classNames?.expanded
        )}
      >
        {children}
      </div>
    </div>
  );
};
